/*
* Pipeline Theme
*
* Use this file to add custom Javascript to Pipeline.  Keeping your custom
* Javascript in this fill will make it easier to update Pipeline. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/

(function () {
  // Suppress the product popdown and open the cart drawer instead on add-to-cart
  let style = document.createElement('style');
  style.textContent = '[data-product-add-popdown-wrapper].is-visible { display: none !important; }';
  document.head.appendChild(style);

  // Intercept fetch to detect when BOGOS finishes its clear/re-add cycle
  let cartActivityTimer = null;
  let pendingDrawerOpen = false;
  let originalFetch = window.fetch;

  window.fetch = function (input) {
    let url = typeof input === 'string' ? input : (input && input.url) || '';
    let result = originalFetch.apply(this, arguments);

    if (pendingDrawerOpen && /\/cart\/(add|update|clear|change)/.test(url)) {
      // Cart activity still happening — reset the settle timer
      clearTimeout(cartActivityTimer);
      result.then(function () {
        cartActivityTimer = setTimeout(openCartDrawer, 600);
      });
    }

    return result;
  };

  function openCartDrawer() {
    pendingDrawerOpen = false;
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.dispatchEvent(new CustomEvent('theme:cart:change', {
          detail: { cart: cart },
          bubbles: true
        }));
        let drawer = document.querySelector('[data-drawer="drawer-cart"]');
        if (drawer) {
          drawer.dispatchEvent(new CustomEvent('theme:drawer:open', { bubbles: false }));
        }
      });
  }

  document.addEventListener('theme:cart:popdown', function () {
    pendingDrawerOpen = true;
    clearTimeout(cartActivityTimer);
    // Give BOGOS a moment to start its cycle, then settle-detect kicks in
    cartActivityTimer = setTimeout(openCartDrawer, 600);
  });

  // Open the side cart drawer when redirected from /cart with ?open_cart=1
  let params = new URLSearchParams(window.location.search);
  if (params.get('open_cart') !== '1') return;

  history.replaceState(null, '', window.location.pathname);

  function openDrawer() {
    let drawer = document.querySelector('[data-drawer="drawer-cart"]');
    if (drawer) {
      drawer.dispatchEvent(new CustomEvent('theme:drawer:open', { bubbles: false }));
    }
  }

  // theme:cart:init fires after the theme cart JS is fully initialized
  document.addEventListener('theme:cart:init', openDrawer, { once: true });

  // Fallback: dispatch after a short delay in case theme:cart:init already fired
  setTimeout(openDrawer, 300);
})();
